'use strict';

import React from 'react';
import axios from 'axios';
import queryBuilder from './queryBuilder';
import parsePolygonCoordinates from './parsePolygonCoordinates';
import parseMarkersCoordinates from './parseMarkersCoordinates';

const getDataFromFB = (
  collection,
  lat,
  lng,
  maxdist,
  loadMapWithMarkers,
  cb,
) => {
  const fbQuery = queryBuilder(
    collection,
    lat,
    lng,
    maxdist,
    loadMapWithMarkers,
  );
  //console.log('loading from fb: ', fbQuery);
  axios
    .get(fbQuery)
    .then(response => {
      //console.info(response);
      const summary = response.data.resultsSummary;
      // if (summary.numRanks < summary.fullyMatching) {
      //   //need to load more results
      // }

      const collectionUpdated = summary.collectionUpdated;
      const results = response.data.results;
      if (results.length > 0) {
        if (loadMapWithMarkers) {
          const markers = parseMarkersCoordinates(results);
          cb({
            markers: markers,
            collLastUpdated: collectionUpdated,
          });
        } else {
          const polygons = parsePolygonCoordinates(results);
          cb({
            polygons: polygons,
            collLastUpdated: collectionUpdated,
          });
        }
      } else {
        cb([]);
      }
    })
    .catch(error => {
      console.log('error', error);

      cb([]);
    });
};

export default getDataFromFB;
